import React, { useState, useEffect } from 'react';
import PropTypes from "prop-types";
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

import { getUser, getAccessToken, resetUserSession } from './service/AuthService';
import { setUserGoal } from './service/GoalService';
import ProblematicLogEntry from './ProblematicLogEntry';
import AudioRecorder from './AudioRecorder'
import Stopwatch from "./Stopwatch";
import Iframe from './Iframe'
import IframeWeb from './IframeWeb'
import Loading from './Loading'
import BrowserNotifications from "./BrowserNotifications";
import { FailureReasonsTextField, TimeSpentSelect, WorkoutTimeSelect, TimeCommitmentSelect, TreatmentsSelect, CaplanScaleNO3Slider, CaplanScaleNO2Slider, CaplanScaleNO1Slider, CaplanScaleCIU3Slider, CaplanScaleCIU2Slider, CaplanScaleCIU1Slider, CaplanScaleCP3Slider, CaplanScaleCP2Slider, CaplanScaleCP1Slider, CaplanScaleMR3Slider, CaplanScaleMR2Slider, CaplanScaleMR1Slider, CaplanScalePOSI1Slider, CaplanScalePOS2Slider, CaplanScalePOS3Slider,  GoalTextField, ProblematicBehaviorsSelect, JoiningReasonSelect, GenderSelect, DOBDatePicker, MateriaBasicTextField, LandingName, MaterialResetPassword, MaterialResetPasswordConfirm } from './MaterialComponents';

import './css/Checkbox.css';
import './css/Daily.css';
import './css/Timeline.css';
import './css/PopupForm.css';
import './css/Success.css';
import './css/Landing.css';

import { OnboardingFriendAdvice, OnboardingGoalsWeek, OnboardingGoalsMonth, OnboardingGoalsQuarter, OnboardingGoalsYear, OnboardingVizSuccess, OnboardingAboutYou} from './MaterialComponents';





//TODO: move this to an environment variable
const onboardingrUrl = 'https://lkrse43p4g.execute-api.us-east-1.amazonaws.com/dev/onboarding';
const dateObj = new Date()

//TODO: personalize this and fetch it from the server
function fetchPersonalizedPlan(){
    let html =
    `<strong>Your Personalized Digital Wellness Plan Powered by Trampoline Health</strong><br><br>
Your journey to healthier screen habits starts now. Trampoline Health provides personalized support, relapse prevention,
and community to keep you accountable. The more you engage, the smarter and more accurate your tailored plan becomes.<br><br>
<hr><br>
<strong>1. Understanding Your Digital Habits</strong><br><br>
<strong>Time Impact:</strong> Even small shifts in screen habits can free up more time for focus, relaxation, and
personal growth. As you track more, we’ll provide insights on where time can be reclaimed.<br><br>
<strong>Patterns & Trends:</strong> Tracking your habits will reveal high-risk times, emotional triggers, and usage
spikes—helping you regain control before overuse happens.<br><br>
<strong>Energy & Focus:</strong> Excessive screen time affects mental clarity and motivation. As you engage with the
platform, we’ll pinpoint small changes that boost focus and well-being.<br><br>
<strong>Next Step:</strong> Complete your first Digital Wellness Workout to start identifying patterns and building
healthier habits.<br><br>
<hr><br>
<strong>2. Recognizing Your Triggers</strong><br><br>
<strong>Common Triggers:</strong> Most people overuse screens due to stress, boredom, procrastination, or habit loops.
The more you track, the better we can help you manage your specific triggers.<br><br>
<strong>High-Risk Situations:</strong> Your most vulnerable times—like late nights, social media breaks, or unstructured
moments—will become clearer as you track. Recognizing these patterns is the first step to change.<br><br>
<strong>Device-Specific Risks:</strong> Some platforms are designed to maximize engagement. We’ll help you identify
which apps disrupt your focus the most and how to regain control.<br><br>
<strong>Next Step:</strong> Log your first setback to begin identifying your unique patterns.<br><br>
<hr><br>
<strong>3. Building a Sustainable System</strong><br><br>
<strong>Alternative Activities:</strong><br>
<strong>Boredom:</strong> Read a book, go for a walk, or listen to a podcast.<br>
<strong>Stress Relief:</strong> Practice deep breathing, mindfulness, or stretching.<br>
<strong>Procrastination:</strong> Use a focus timer (like Pomodoro) to stay on track.<br><br>
<strong>Environmental Adjustments:</strong><br>
Keep your phone outside the bedroom at night.<br>
Create a work-only space free from digital distractions.<br><br>
<strong>Accountability & Support:</strong> Join the Trampoline Health Community to ask questions, share progress, and
stay accountable.<br><br>
<strong>Next Step:</strong> Introduce yourself in the Trampoline Health Community and set a personal goal for the
week.<br><br>
<hr><br>
<strong>4. Setting Boundaries That Work</strong><br><br>
<strong>Non-Negotiable Rules:</strong><br>
No screens one hour before bed.<br>
No phone use during meals or social time.<br>
Work-first approach (no social media before finishing key tasks).<br><br>
<strong>Recognizing ‘Stop Signals’:</strong> Signs like guilt, stress, or fatigue after screen overuse mean it’s time to
pause. Logging these moments will help you spot them faster.<br><br>
<strong>Reducing Distractions:</strong><br>
Turn off non-essential notifications.<br>
Move distracting apps off your home screen.<br>
Set up Focus Modes or scheduled "Do Not Disturb" periods.<br><br>
<strong>Next Step:</strong> Set a small boundary goal inside the Trampoline Health community and track your progress
there.<br><br>
<hr><br>
<strong>5. Responding to Setbacks</strong><br><br>
<strong>Recognizing Early Warning Signs:</strong> If you notice anxiety, mindless scrolling, or avoidance behaviors,
it’s time to pause and reflect. Logging these moments will help prevent them from becoming habits.<br><br>
<strong>Adjusting Based on Risk Level:</strong><br>
<strong>Mild distraction:</strong> Take a short break and reset.<br>
<strong>Moderate overuse:</strong> Switch to an alternative activity and note what triggered it.<br>
<strong>Severe habit disruption:</strong> Seek support in the Trampoline Health Community or revisit your
Prevention Plan.<br><br>
<strong>Learning from Relapses:</strong> Every setback is an opportunity to adjust and improve. Tracking them helps you
see progress over time.<br><br>
<strong>Next Step:</strong> Log a recent setback in the app and review your patterns.<br><br>
<hr><br>
<strong>Next Steps with Trampoline Health</strong><br><br>
Your plan evolves with you. The more you engage, the more personalized and effective it becomes.<br><br>
<strong>1. Complete your first Digital Wellness Workout.</strong><br>
Helps you identify patterns and create a personalized improvement plan.<br><br>
<strong>2. Log your first screen time entry or setback.</strong><br>
Real data enables smarter recommendations tailored to your habits.<br><br>
<strong>3. Join the Trampoline Health Community.</strong><br>
Get support, ask questions, and stay accountable in a judgment-free space.<br><br>
<strong>4. Set one clear boundary goal inside the platform.</strong><br>
Small commitments lead to big, sustainable changes.<br><br>
As you continue, Trampoline Health will provide more personalized recommendations, relapse support, and structured
wellness workouts to help you build sustainable, balanced screen habits.<br><br>
    `
    return html
}



//TODO: move this to an environment variable


const LandingForm = () => {
    const backArrowIcon = (
        <svg width="22" height="22" viewBox="0 0 14 14" fill="none" aria-hidden="true">
            <path
                d="M11 7H3M7 3L3 7l4 4"
                stroke="currentColor"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );

    const nextArrowIcon = (
        <svg width="20" height="20" viewBox="0 0 14 14" fill="none" aria-hidden="true">
            <path
                d="M3 7h8M7 3l4 4-4 4"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );

    

    //Onboarding Log 
    const [onboardingPass, setonboardingPass] = useState('');
    


    //new onboarding screens
    const [onboardingScreenAboutYou, setOnboardingScreenAboutYou] = useState('');
    const [onboardingScreenVizSuccess, setOnboardingScreenVizSuccess] = useState('');
    const [onboardingScreenGoalsYear, setOnboardingScreenGoalsYear] = useState('');
    const [onboardingScreenGoalsThreeMonth, setOnboardingScreenGoalsThreeMonth] = useState('');
    const [onboardingScreenGoalsMonth, setOnboardingScreenGoalsMonth] = useState('');
    const [onboardingScreenGoalsWeek, setOnboardingScreenGoalsWeek] = useState('');
    const [onboardingScreenFriendAdvice, setOnboardingScreenFriendAdvice] = useState('');
    const [relapsePlan, setRelapsePlan] = useState('');
    
    //Relapse Prevention Plan
    const [relapsePlanText, setRelapsePlanText] = useState(fetchPersonalizedPlan());



    //Learning Form Data (move it here)
    //Updated questions after new landing form
    const [aboutYou, setAboutYou] = useState('');
    function handleAboutYou(newValue) {
        setAboutYou(newValue);
    }
    const [vizSuccess, setVizSuccess] = useState('');
    function handleVizSuccess(newValue) {
        setVizSuccess(newValue);
    }
    const [goalsYear, setGoalsYear] = useState('');
    function handleGoalsYear(newValue) {
        setGoalsYear(newValue);
    }
    const [goalsQuarter, setGoalsQuarter] = useState('');
    function handleGoalsQuarter(newValue) {
        setGoalsQuarter(newValue);
    }
    const [goalsMonth, setGoalsMonth] = useState('');
    function handleGoalsMonth(newValue){
        setGoalsMonth(newValue);
    }
    const [goalsWeek, setGoalsWeek] = useState('');
    function handleGoalsWeek(newValue) {
        setGoalsWeek(newValue);
    }
    const [friendAdvice, setFriendAdvice] = useState('');
    function handleFriendAdvice(newValue) {
        setFriendAdvice(newValue);
    }

    const [newPassword, setNewpassword] = useState('');
    function handleNewpassword(newValue) {
        setNewpassword(newValue);
    }
    const [newPasswordConfirm, setNewpasswordConfirm] = useState('');
    function handleNewpasswordConfirm(newValue) {
        setNewpasswordConfirm(newValue);
    }


    const user = getUser();
    const token = getAccessToken();
    // const name = user !== 'undefined' && user ? user.name: '';
    const username = user !== 'undefined' && user ? user.username: '';

    const [errorMessage, setErrorMessage] = useState('');
    const [isLoading, setLoading] = useState(true);
    const [dailyContent, setDailyContent] = useState('');


    //Popup
    const [currentQuestion, setCurrentQuestion] = useState(0);
    const [answers, setAnswers] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [showLearningPopup, setShowLearningPopup] = useState(false);
    const [showonboardingPopup, setShowonboardingPopup] = useState(false);
    
    const [journalAudio, setAudio] = useState(null);

    const navigate = useNavigate()

    //Onboarding Log 
    const [onboardingIntro, setonboardingIntro] = useState('');
    const [onboardingTime, setonboardingTime] = useState('');
    const [onboardingBackground, setonboardingBackground] = useState('');
    const [onboardingInformation, setonboardingInformation] = useState('');
    const [onboardingScreenStart, setOnboardingScreenStart]= useState('');
    const [onboardingWhy, setonboardingWhy] = useState('');
    const [onboardingImpact, setonboardingImpact] = useState('');
    const [onboardingScreen, setOnboardingScreen] = useState('');
    const [onboardingScreen2, setOnboardingScreen2] = useState('');
    const [onboardingScreen3, setOnboardingScreen3] = useState('');
    const [onboardingScreen4, setOnboardingScreen4] = useState('');
    const [onboardingSuccess, setonboardingSuccess] = useState('');
    const [onboardingTimeWasted, setOnboardingTimeWasted] = useState('');
    const [onboardingScreenerResults, setOnboardingScreenerResults] = useState('');
    const [onboardingCalltoAction, setOnboardingCalltoAction] = useState('');



    //Learning Form Data (move it here)
    const [name, setName] = useState('');
        function handleName(newValue) {
            setName(newValue);
    }

    const [dateofbirth, setDateofbirth] = useState('');
    function handleDateofbirth(newValue) {
        setDateofbirth(newValue);
    }

    const [gender, setGender] = useState('');
    let genderCurr = []
    function handleGender(newValue) {
        setGender(newValue);
        genderCurr = newValue
        //console.log('set gender to: ', newValue)
        //console.log('gender now is: ', gender)
    }

    const [email, setEmail] = useState('');
    function handleEmail(newValue) {
        setEmail(newValue);
    }
    

    const [joiningReason, setJoiningReason] = useState('');
    function handleJoiningReason(newValue) {
        setJoiningReason(newValue);
    }

    const [timeSpent, setTimeSpent] = useState('');
    function handleTimeSpent(newValue) {
        setTimeSpent(newValue);
    }

    const [problematicBehaviors, setProblematicBehaviors] = useState(0);
    function handleProblematicBehaviors(newValue) {
        setProblematicBehaviors(newValue);
    }

    const [caplanScalePOSI1, setCaplanScalePOSI1] = useState(0);
    function handleCaplanScalePOSI1(newValue) {
        setCaplanScalePOSI1(newValue);
    }

    const [caplanScalePOSI2, setCaplanScalePOSI2] = useState(0);
    function handleCaplanScalePOSI2(newValue) {
        setCaplanScalePOSI2(newValue);
    }

    const [caplanScalePOSI3, setCaplanScalePOSI3] = useState(0);
    function handleCaplanScalePOSI3(newValue) {
        setCaplanScalePOSI3(newValue);
    }

    const [caplanScaleMR1, setCaplanScaleMR1] = useState(0);
    function handleCaplanScaleMR1(newValue) {
        setCaplanScaleMR1(newValue);
    }

    const [caplanScaleMR2, setCaplanScaleMR2] = useState(0);
    function handleCaplanScaleMR2(newValue) {
        setCaplanScaleMR2(newValue);
    }

    const [caplanScaleMR3, setCaplanScaleMR3] = useState(0);
    function handleCaplanScaleMR3(newValue) {
        setCaplanScaleMR3(newValue);
    }

    const [caplanScaleCP1, setCaplanScaleCP1] = useState(0);
    function handleCaplanScaleCP1(newValue) {
        setCaplanScaleCP1(newValue);
    }

    const [caplanScaleCP2, setCaplanScaleCP2] = useState(0);
    function handleCaplanScaleCP2(newValue) {
        setCaplanScaleCP2(newValue);
    }

    const [caplanScaleCP3, setCaplanScaleCP3] = useState(0);
    function handleCaplanScaleCP3(newValue) {
        setCaplanScaleCP3(newValue);
    }

    const [caplanScaleCIU1, setCaplanScaleCIU1] = useState(0);
    function handleCaplanScaleCIU1(newValue) {
        setCaplanScaleCIU1(newValue);
    }

    const [caplanScaleCIU2, setCaplanScaleCIU2] = useState(0);
    function handleCaplanScaleCIU2(newValue) {
        setCaplanScaleCIU2(newValue);
    }

    const [caplanScaleCIU3, setCaplanScaleCIU3] = useState(0);
    function handleCaplanScaleCIU3(newValue) {
        setCaplanScaleCIU3(newValue);
    }

    const [caplanScaleNO1, setCaplanScaleNO1] = useState(0);
    function handleCaplanScaleNO1(newValue) {
        setCaplanScaleNO1(newValue);
    }

    const [caplanScaleNO2, setCaplanScaleNO2] = useState(0);
    function handleCaplanScaleNO2(newValue) {
        setCaplanScaleNO2(newValue);
    }

    const [caplanScaleNO3, setCaplanScaleNO3] = useState(0);
    function handleCaplanScaleNO3(newValue) {
        setCaplanScaleNO3(newValue);
    }


    const [triedTreatments, setTriedTreatments] = useState('');
    function handleTriedTreatments(newValue) {
        setTriedTreatments(newValue);
    }

    const [failureReasons, setFailureReasons] = useState('');
    function handleFailureReasons(newValue) {
        setFailureReasons(newValue);
    }

    const [timeCommitment, setTimeCommitment] = useState('');
    function handleTimeCommitment(newValue) {
        setTimeCommitment(newValue);
    }

    const [workoutTime, setWorkoutTime] = useState('');
    function handleWorkoutTime(newValue) {
        setWorkoutTime(newValue);
    }

    const [currentGoal, setCurrentGoal] = useState('');
    function handleCurrentGoal(newValue) {
        setCurrentGoal(newValue);
    }

    //Onboarding Entries
    const entries = []
    const [entryHTML, setEntryHTML] = useState(null);
    const [lastSubmitDate, setLastSubmitDate] = useState('');
    const [lastTitle, setLastTitle] = useState('');
    const [lastDescription, setLastDescription] = useState('');
    const [lastLesson, setLastLesson] = useState('');
    const [lastImpact, setLastImpact] = useState('');

    //
    const [timeSpendYearText, setTimeSpendYearText] = useState('');
    const [lifetimeSpendText, setLifetimeSpendText] = useState('');
    const [riskFactorText, setRiskFactorText] = useState('');
    const [timeSavedText, setTimeSavedText] = useState('');

    //Spinner
    const loadingSpinner = document.querySelector('.donut');

    
    function setOnboardingForm(){
        setonboardingIntro(
            <div className="learningFeedback">
                <div>
                    <p className="questionInfo" style={{ fontSize:' 0.75em'}}> Trampoline Health is a virtual and physical space for us to <b>build our mental wellness together</b>. To get started, we need to learn a bit about you. Please take a moment to fill out this brief form to help us better understand you. With your help, we can craft the <b>perfect mental wellness program for you</b>! </p>
                </div>
                <div className="formBttnContainer" style={{ bottom:' 5rem'}}>
                    <button className="popupButton" onClick={handleNextQuestion} >Dive in!</button>
                </div>
            </div> 
        )
        setonboardingTime(
            <div className="learningFeedback">
                <div>
                    <p className="questionInfo"> Let’s start with learning more about you.  </p>
                </div>
                <div>
                    <div className="onboardingQuestion">Date of Birth:</div>
                    {/* <input type="text" value={morningUse} placeholder="1-10 (1 as in poor 10 as in great)" onChange={event => setMorningUse(event.target.value)} /> <br /> */}
                    <DOBDatePicker handleChange={handleDateofbirth}/>
                </div>
                <div>
                    <div className="onboardingQuestion">Name:</div>
                    {/* <input type="text" value={morningUse} placeholder="1-10 (1 as in poor 10 as in great)" onChange={event => setMorningUse(event.target.value)} /> <br /> */}
                    <LandingName label="Name" handleChange={handleName}/>
                </div>
                <div>
                    <div className="onboardingQuestion">Gender:</div>
                    <GenderSelect multipleSelect = 'false' label='Gender' elements={['Woman', 'Man', 'Nonbinary', 'Other']} handleChange={handleGender} defaultValue={gender}/>
                </div>

            </div> 
        )
        setonboardingBackground(
            <div className="learningFeedback">
                {/* <div>
                    <p className="questionInfo"> Let's dig a little deeper.</p>
                </div> */}
                <div>
                    {/* <div className="form-group"><label> If you had to pick one current life goal to complete in the next 3 months what would it be?: </label><br /> <input type="text" placeholder='Goal should be Specific, Measurable, Achievable, Relevant, and Time - Bound' value={currentGoal} onChange={event => setCurrentGoal(event.target.value)} /> <br /></div> */}
                    <div className="onboardingQuestion" >What is an important goal that your mental wellness has gotten in the way of?</div>
                    <GoalTextField handleChange={handleCurrentGoal} placeholder='' />
                </div>
                <div>
                    <div className="onboardingQuestion">On a typical day, how many hours do you spend on things that don’t energize or fulfill you?</div>
                    {/* <input type="text" value={morningUse} placeholder="1-10 (1 as in poor 10 as in great)" onChange={event => setMorningUse(event.target.value)} /> <br /> */}
                    <TimeSpentSelect  multipleSelect = 'false' handleChange={handleTimeSpent} label='Time' elements={['<3 hours', '3-7 hours', '7-12 hours', '13+ hours ']}/>
                </div>
            </div> 
        )
        setonboardingInformation(
            <div className="learningFeedback">
                <div>
                    <p className="questionInfo" style={{ fontSize:' 0.8em'}}>   The following section helps us understand your mental wellness patterns so we can better support your growth.
  Some questions may feel repetitive. That’s intentional. They help us paint a clearer picture.</p>
                    <p className="questionInfo" style={{ fontSize:' 0.8em'}}>  <b>Instructions:</b> Please rate how much you agree with each statement, from 1 (Definitely Disagree) to 8 (Definitely Agree). </p>
                </div>
            </div> 
        )
        setOnboardingScreenStart(
            <div className="learningFeedback">
                <div>
                    <div className="onboardingQuestion">I tend to avoid difficult thoughts or feelings</div>
                    <CaplanScaleMR3Slider handleChange={handleCaplanScaleMR3} min='1' max='8'/>
                </div>
                <div>
                    <div className="onboardingQuestion">I have missed social engagements or activities because of my mental wellness</div>
                    <CaplanScaleNO2Slider handleChange={handleCaplanScaleNO2} min='1' max='8'/>
                </div>
                <div>
                    <div className="onboardingQuestion">I struggle to stay present or focused in my day-to-day life</div>
                    <CaplanScaleCIU3Slider handleChange={handleCaplanScaleCIU3} min='1' max='8'/>
                </div>
            </div> 
        )
        setonboardingImpact(
            <div className="learningFeedback">
                <div>
                    <div className="onboardingQuestion">My mental wellness has gotten in the way of showing up how I want to in life.</div>
                    <CaplanScaleCIU1Slider handleChange={handleCaplanScaleCIU1} min='1' max='8'/>
                </div>

                <div>
                    <div className="onboardingQuestion">I find it difficult to regulate my thoughts or emotions when I'm overwhelmed.</div>
                    <CaplanScaleMR2Slider handleChange={handleCaplanScaleMR2} min='1' max='8'/>
                </div>
                <div>
                    <div className="onboardingQuestion">When I’m down, I often cope in ways that don’t actually help me feel better.</div>
                    <CaplanScaleNO1Slider handleChange={handleCaplanScaleNO1} min='1' max='8'/>
                </div>
            </div> 
        )
        
        setOnboardingScreen3(
            <div className="learningFeedback">
                <div>
                    <div className="onboardingQuestion">Why hasn’t what you’ve tried worked long term?</div>
                    <FailureReasonsTextField handleChange={handleFailureReasons} placeholder="" rows="2"/>
                </div>
                <div>
                    <div className="onboardingQuestion">What have you tried?</div>
                    {/* <input type="text" value={morningUse} placeholder="1-10 (1 as in poor 10 as in great)" onChange={event => setMorningUse(event.target.value)} /> <br /> */}
                    <TreatmentsSelect handleChange={handleTriedTreatments} label='Solution(s) - multiple select' elements={['Therapy', 'Journaling', 'Mindfulness', 'Support Group', 'Medication', 'Exercise', 'Nothing Yet', 'Other']}/>
                </div>
            </div> 
        )
        setOnboardingScreen4(
            <div className="learningFeedback">
                <div>
                    <h5 className="questionInfo"> Commit improving your digital use and overall wellness. Let's put in the work.</h5>
                </div>
                <div>
                    <div className="onboardingQuestion"> How many times a week do you commit to work on your digital health?</div>
                    <TimeCommitmentSelect handleChange={handleTimeCommitment} multipleSelect='false' label='Times per Week' elements={['3 times', '5 times', '7 times']}/>
                </div>
                <div>
                    {/* <div className="form-group"><label> If you had to pick one current life goal to complete in the next 3 months what would it be?: </label><br /> <input type="text" placeholder='Goal should be Specific, Measurable, Achievable, Relevant, and Time - Bound' value={currentGoal} onChange={event => setCurrentGoal(event.target.value)} /> <br /></div> */}
                    <div className="onboardingQuestion"> At what time do you plan to do your workouts?</div>
                    {/* <MateriaBasicTextField handleChange={handleCurrentGoal} placeholder='Goal' /> */}
                    <WorkoutTimeSelect handleChange={handleWorkoutTime}/>
                </div>
            </div> 
        )
        // const [onboardingTimeWasted, setOnboardingTimeWasted] = useState('');
        // const [onboardingScreenerResults, setOnboardingScreenerResults] = useState('');
        // const [onboardingCalltoAction, setOnboardingCalltoAction] = useState('');
        setonboardingSuccess(
            <div className="learningFeedback">
                <div>
                    <div style={{ display: 'flex', justifyContent: 'center'}}>
                        <p className="questionInfo"> Mental wellness is is a journey not a destination. Analyzing your responses... </p>
                    </div>
                    {/* <div style={{ marginTop: '5rem'}} id='waiting-animation'>
                        <Loading/>
                    </div> */}
                    <div style={{ marginTop: '5rem', textAlign:'center'}} id='waiting-text' >
                        <h4>Ready to begin? <br></br>Click next to see results 🥳 ✨.</h4>
                    </div>
                </div>
            </div> 
            
        )
        setOnboardingTimeWasted(
            <div className="learningFeedback">
                <div>
                    <p className="questionInfo">  We calculated you will spend <b>12 days</b> on things that leave you drained or unfulfilled. Looking ahead this means that you will spend </p>
                    <h1 style={{ textAlign: 'center'}} > 12 years</h1>
                    <p className="questionInfo">  of your life lost to patterns that aren’t serving you. What else could you do in <b>12 years</b>?</p>

                </div>
                </div> 
            )
        setOnboardingScreenerResults(
                <div className="learningFeedback">
                    <div>
                        <p className="questionInfo"> Conditions like <b>anxiety, depression, and obesity</b> are more common than ever. It's normal to feel overwhelmed but you can change how you respond. Be more present and build</p>
                        <h1
                            style={{
                                textAlign: 'center',
                                color: '#FFFFFF',
                                fontFamily: "'Fraunces', serif",
                                fontWeight: 300,
                                fontSize: 'clamp(2.4rem, 8vw, 3.25rem)',
                                lineHeight: 1.1,
                                letterSpacing: '-0.02em',
                                margin: '0 0 0.55rem',
                                textShadow: '0 2px 16px rgba(0, 0, 0, 0.55)'
                            }}
                        >
                            Resilience
                        </h1>
                        <p className="questionInfo"> at our mental wellness gym. Trampoline Health can help you finally <b>make the change</b>.</p>

                    </div>
                </div>
            )
        setOnboardingCalltoAction(
            <div className="learningFeedback">
                <div>
                    <p className="questionInfo">  Trampoline can help you recover </p>
                    <h1 style={{ textAlign: 'center'}} >12 years +</h1>
                    <p className="questionInfo">  of your life and more importantly help you <b>fill up that time with what matters.</b></p>

                </div>
                <div className="formBttnContainer" style={{bottom:'4.0rem'}}>
                    <button className="popupButton"  onClick={handleCloseRelapsePopup} >Start Your First Workout</button>
                    <button style={{ marginTop: '1rem' }} className="popupButton" onClick={() => {window.open("https://whop.com/joined/trampoline-health/wins-goals-and-takeaways-5Hrc6ecDw1APCe/app/", "_blank");}} >Share Progress In Mental Wellness Gym</button>
                </div>
            </div> 
        )


        ////////////////////////////////////////////////////////////// SECONDARY ONBOARDING
         // const [onboardingScreenAboutYou, setOnboardingScreenAboutYou] = useState('');
        // const [onboardingScreenVizSuccess, setOnboardingScreenVizSuccess] = useState('');
        // const [onboardingScreenGoalsYear, setOnboardingScreenGoalsYear] = useState('');
        // const [onboardingScreenGoalsThreeMonth, setOnboardingScreenGoalsThreeMonth] = useState('');
        // const [onboardingScreenGoalsMonth, setOnboardingScreenGoalsMonth] = useState('');
        // const [onboardingScreenGoalsWeek, setOnboardingScreenGoalsWeek] = useState('');
        // const [onboardingScreenFriendAdvice, setOnboardingScreenFriendAdvice] = useState('');
        //new questions
        setOnboardingScreenAboutYou(
            <div className="learningFeedback">
                <div>
                    <p className="questionInfo" style={{ marginBottom: '1rem' }}> Let’s start with learning more about you. </p>
                </div>
                <div>
                    <div className="onboardingQuestion">Tell us about yourself. What background would help us craft your personalized mental wellness plan?</div>
                    <OnboardingAboutYou placeholder="" handleChange={ handleAboutYou }/>
                </div>
                <div>
                    <div className="onboardingQuestion">Why do you want to join?</div>
                    {/* <input type="text" value={morningUse} placeholder="1-10 (1 as in poor 10 as in great)" onChange={event => setMorningUse(event.target.value)} /> <br /> */}
                    <JoiningReasonSelect handleChange={handleJoiningReason} label='Where can we help - multiple select' elements={['Decrease Anxiety', 'Improve Well Being ', 'Improve Relationships ', 'Improve Mental Health', 'Improve Physical Health', 'Decrease Loneliness', 'Increase Self-Fulfillment', 'Improve Sleep', 'Improve Productivity']}/>
                </div>
            </div> 
        )
        setOnboardingScreenVizSuccess(
            <div className="learningFeedback">
                <div>
                    <p className="questionInfo"> Let’s start with learning more about you.  </p>
                </div>
                <div>
                    <div style={{ marginBottom: '1rem' }} className="relapseQuestion">Imagine a life where you are mentally strong and emotionally fit. What does it look like?</div>
                    <OnboardingVizSuccess placeholder="" handleChange={ handleVizSuccess }/>
                </div>
            </div> 
        )
        
        setOnboardingScreenFriendAdvice(
            <div className="learningFeedback">
                <div>
                    <p className="questionInfo"> Sometimes, the best advice we give others is the advice we need ourselves. Reflect on what you'd say to support someone starting their journey. </p>
                </div>
                <div>
                    <div style={{ marginBottom: '1rem' }} className="relapseQuestion">What advice would you give a close friend starting this journey of growth?</div>
                    <OnboardingFriendAdvice placeholder="" handleChange={ handleFriendAdvice }/>
                </div>
            </div> 
        )

        //separator ----------------

        setonboardingIntro(
            <div className="learningFeedback">
                <div>
                    <p className="questionInfo" style={{ fontSize:' 0.75em'}}> We'd love to learn a bit about you and your goals so we can customize your experience. Please take a moment to fill out our quick onboarding form. With your help, we'll craft the perfect program for you!  </p>
                </div>
            </div> 
        )
        setonboardingPass(
            <div className="learningFeedback">
                <div>
                    <p className="questionInfo"> First let's reset your password.  </p>
                </div>
                <div>
                    <div className="onboardingQuestion">New Password:</div>
                    {/* <input type="text" value={morningUse} placeholder="1-10 (1 as in poor 10 as in great)" onChange={event => setMorningUse(event.target.value)} /> <br /> */}
                    <MaterialResetPassword handleChange={handleNewpassword} placeholder='Password' />
                </div>
                <div>
                    <div className="onboardingQuestion">Confirm New Password:</div>
                    {/* <input type="text" value={morningUse} placeholder="1-10 (1 as in poor 10 as in great)" onChange={event => setMorningUse(event.target.value)} /> <br /> */}
                    <MaterialResetPasswordConfirm handleChange={handleNewpasswordConfirm} placeholder='Password' />
                </div>
            </div> 
        )
        // setonboardingTime(
        //     <div className="learningFeedback">
        //         <div>
        //             <p className="questionInfo"> Let’s start with learning more about you.  </p>
        //         </div>
        //         {/* <div>
        //             <div className="onboardingQuestion">Date of Birth</div>
        //             <DOBDatePicker handleChange={handleDateofbirth}/>
        //         </div> */}
        //         {/* <div>
        //             <div className="onboardingQuestion">What are you looking to cut back on?</div>
        //             <ProblematicBehaviorsSelect handleChange={handleProblematicBehaviors} label='Behavior(s) - multiple select' elements={['Social Media', 'Video Streaming', 'Gaming', 'Porn', 'Gambling', 'Other']}/>
        //         </div> */}
        //         <div>
        //             <div className="onboardingQuestion">Why do you want to join?</div>
        //             {/* <input type="text" value={morningUse} placeholder="1-10 (1 as in poor 10 as in great)" onChange={event => setMorningUse(event.target.value)} /> <br /> */}
        //             <JoiningReasonSelect handleChange={handleJoiningReason} label='Where can we help - multiple select' elements={['Decrease Anxiety', 'Improve Well Being ', 'Improve Relationships ', 'Improve Mental Health', 'Improve Physical Health', 'Decrease Loneliness', 'Increase Self-Fulfillment', 'Improve Sleep', 'Improve Productivity']}/>
        //         </div>
        //     </div> 
        // )
        
        // setOnboardingScreen3(
        //     <div className="learningFeedback">
        //         <div>
        //             <div style={{ marginBottom: '1rem' }} className="onboardingQuestion">My Internet use has created problems for me in my life.</div>
        //             <CaplanScaleNO3Slider handleChange={handleCaplanScaleNO3} min='1' max='8'/>
        //         </div>
        //         <div>
        //             <div className="onboardingQuestion">What have you tried?</div>
        //             {/* <input type="text" value={morningUse} placeholder="1-10 (1 as in poor 10 as in great)" onChange={event => setMorningUse(event.target.value)} /> <br /> */}
        //             <TreatmentsSelect handleChange={handleTriedTreatments} label='Alternative(s) - multiple select' elements={['Therapy', 'App Blockers', 'Support Group', 'Mindfulness', 'Dumb Phone', 'Physical Limiter', 'Nothing Yet', 'Other']}/>
        //         </div>
        //         <div>
        //             <div className="onboardingQuestion">Why hasn’t what you’ve tried worked long term?</div>
        //             <FailureReasonsTextField handleChange={handleFailureReasons} placeholder="Think about what you have tried and why changes haven't stuck" rows="2"/>
        //         </div>
        //     </div> 
        // )
        setOnboardingScreen4(
            <div className="learningFeedback">
                <div>
                    <h5 className="questionInfo"> Commit improving your emotional fitness and overall wellness. Let's put in the work.</h5>
                </div>
                <div>
                    <div className="onboardingQuestion" style={{ marginBottom: '1rem' }} >How many times a week do you commit to work on your mental wellness?</div>
                    <TimeCommitmentSelect handleChange={handleTimeCommitment} multipleSelect='false' label='Times per Week' elements={['3 times', '5 times', '7 times']}/>
                </div>
                <div>
                    {/* <div className="form-group"><label> If you had to pick one current life goal to complete in the next 3 months what would it be?: </label><br /> <input type="text" placeholder='Goal should be Specific, Measurable, Achievable, Relevant, and Time - Bound' value={currentGoal} onChange={event => setCurrentGoal(event.target.value)} /> <br /></div> */}
                    <div className="onboardingQuestion" style={{ marginBottom: '1rem' }} >At what time do you plan to do your mental wellness workouts?</div>
                    {/* <MateriaBasicTextField handleChange={handleCurrentGoal} placeholder='Goal' /> */}
                    <WorkoutTimeSelect handleChange={handleWorkoutTime}/>
                </div>
            </div> 
        )
        setonboardingSuccess(
            <div className="learningFeedback">
                <div>
                    <p className="questionInfo"> Mental wellness is is a journey not a destination. Creating your personalized road map... </p>
                </div>
                <div style={{ marginTop: '5rem'}} >
                    <Loading/>
                </div>
            </div> 
        )
        setRelapsePlan(
            <div className="learningFeedback">
                <div style={{overflowY: "auto", height: "80%", minHeight:"400px", textAlign: "center" }} dangerouslySetInnerHTML={{__html: relapsePlanText}} >
                </div>
                <div className="formBttnContainer" style={{ bottom: '0rem' }}>
                    <button className="popupButton" style={{ marginTop: '1rem' }} onClick={handleCloseRelapsePopup} >Commit To Plan</button>
                </div>
            </div> 
        )

    }



    function stringToHTML (str) {
        // If DOMParser is supported, use it
        let support = true
        if (!window.DOMParser) support = false;
        let parser = new DOMParser();
        try {
            parser.parseFromString('x', 'text/html');
        } catch(err) {
            support = false;
        }
        if (support) {
            let parser = new DOMParser();
            var doc = parser.parseFromString(str, 'text/html');
            //console.log('yo7', dom)
            return doc.body;
        }

        // Otherwise, fallback to old-school method
        var dom = document.createElement('div');
        dom.innerHTML = str;
        //console.log('yooo')
        //console.log('yo7', dom)
        return dom;
    };

    function randomArrVal(arr){
        return arr[Math.floor(Math.random() * arr.length)];
    }
    
    //Popup
    let questionsonboarding = [
        {
            question: "Let's Start Your Mental Wellness Journey!",
            assets: onboardingIntro,
            subheading: 'Test',
            input: '<textarea className="textinput" name="paragraph_text" cols="50" value={contentFeedback} onChange={event => setContentFeedback(event.target.value)}></textarea>'
        },
        {
            question: 'Onboarding',
            assets: onboardingPass,
            errorMessage: errorMessage
        },
        {
            question: 'Building Your Mental Wellness Plan',
            assets: onboardingTime,
        },
        {
            question: 'Building Your Mental Wellness Plan',
            assets: onboardingBackground,
            answers: gender
        },
        {
            question: 'Building Your Mental Wellness Plan',
            assets: onboardingInformation,
        },
        {
            question: 'Building Your Mental Wellness Plan',
            assets: onboardingScreenStart,
        },
        // {
        //     question: 'Building Your Digital Wellness Plan',
        //     assets: onboardingWhy,
        // },
        {
            question: 'Building Your Mental Wellness Plan',
            assets: onboardingImpact,
        },
        // {
        //     question: 'Building Your Digital Wellness Plan',
        //     assets: onboardingScreen,
        // },
        // {
        //     question: 'Building Your Digital Wellness Plan',
        //     assets: onboardingScreen2,
        // },
        {
            question: 'Building Your Mental Wellness Plan',
            assets: onboardingScreen3,
        },
        // {
        //     question: 'Welcome to Trampoline Health!',
        //     assets: onboardingSuccess,
        // },
       
        {
            question: 'Getting Started',
            assets: onboardingScreenAboutYou,
        },
        {
            question: 'Getting Started',
            assets: onboardingScreenVizSuccess,
        },
        // {
        //     question: 'Goal Setting',
        //     assets: onboardingScreenGoalsYear,
        // },
        // {
        //     question: 'Goal Setting',
        //     assets: onboardingScreenGoalsThreeMonth,
        // },
        // {
        //     question: 'Goal Setting',
        //     assets: onboardingScreenGoalsMonth,
        // },
        // {
        //     question: 'Goal Setting',
        //     assets: onboardingScreenGoalsWeek
        // },
        {
            question: 'Take the First Step',
            assets: onboardingScreenFriendAdvice,
        },
        {
            question: 'Take the First Step',
            assets: onboardingScreen4,
        },
        // {
        //     question: 'Welcome to Trampoline Health!',
        //     assets: onboardingSuccess,
        // },
        // {
        //     question: 'Prevention Plan',
        //     assets: relapsePlan,
        // },
         {
            question: 'Welcome to Trampoline Health!',
            assets: onboardingTimeWasted,
        },
        {
            question: 'Welcome to Trampoline Health!',
            assets: onboardingScreenerResults,
        },
        {
            question: 'Welcome to Trampoline Health!',
            assets: onboardingCalltoAction,
        }
    ];

    const handleonboardingSupport = () => {
        //console.log('handling onboarding support')
        setShowPopup(true);
        document.getElementById('learning-popup').style.display = "none";
        document.getElementById('onboarding-popup').style.display = "block";
        document.getElementsByClassName("popupContainer")[1].style.visibility =  "visible"
    };

    const handleNextQuestion = () => {
        setCurrentQuestion(currentQuestion + 1);
        // alert(currentQuestion)
        if (currentQuestion === 3){
            //get amount of time and push it over to days this year and years in front of screen
            let timeSpendOptions = ['<3 hours', '3-7 hours', '7-12 hours', '13+ hours ']
            let timeSpendEstimates = [3, 7, 12, 15]
            const index = timeSpendOptions.indexOf(timeSpent[0]);

            let numTimeSpent = parseInt(timeSpendEstimates[index])
            let timeSpendYear = Math.ceil((numTimeSpent * 7 * 52 )* (1/24))
            let multiplier = 1/(365)
            let lifetimeSpend = Math.ceil(timeSpendYear * 79 * multiplier)

            //time saved calculations -- improve these in the future
            let timeSavedMulti = 0.3
            let timeSaved = Math.ceil(lifetimeSpend * timeSavedMulti)
            let personalGoal = currentGoal

            setTimeSpendYearText(timeSpendYear)
            setLifetimeSpendText(lifetimeSpend)
            setTimeSavedText(timeSaved)

            //console.log(timeSpent[0])
            //console.log(index)
            //console.log('time spent in day', numTimeSpent)
            //console.log('time spent in week', numTimeSpent * 7)
            //console.log('time spent in year', timeSpendYear)
            //console.log(lifetimeSpend)      
            //sum up all of the form data and see in which range it is
            let caplanScalePOSI1Num = parseInt(caplanScalePOSI1)
            let caplanScalePOSI2Num = parseInt(caplanScalePOSI2)
            let caplanScalePOSI3Num = parseInt(caplanScalePOSI3)
            let caplanScaleMR1Num = parseInt(caplanScaleMR1)
            let caplanScaleMR2Num = parseInt(caplanScaleMR2)
            let caplanScaleMR3Num = parseInt(caplanScaleMR3)
            let caplanScaleCP1Num = parseInt(caplanScaleCP1)
            let caplanScaleCP2Num = parseInt(caplanScaleCP2)
            let caplanScaleCP3Num = parseInt(caplanScaleCP3)
            let caplanScaleCIU1Num = parseInt(caplanScaleCIU1)
            let caplanScaleCIU2Num = parseInt(caplanScaleCIU2)
            let caplanScaleCIU3Num = parseInt(caplanScaleCIU3)
            let caplanScaleNO1Num = parseInt(caplanScaleNO1)
            let caplanScaleNO2Num = parseInt(caplanScaleNO2)
            let caplanScaleNO3Num = parseInt(caplanScaleNO3)
           
            let totalPOSI = caplanScalePOSI1Num+caplanScalePOSI2Num+caplanScalePOSI3Num
            let totalMR = caplanScaleMR1Num+caplanScaleMR2Num+caplanScaleMR3Num
            let totalCP = caplanScaleCP1Num+caplanScaleCP2Num+caplanScaleCP3Num
            let totalCIU = caplanScaleCIU1Num+caplanScaleCIU2Num+caplanScaleCIU3Num
            let totalNO= caplanScaleNO1Num+caplanScaleNO2Num+caplanScaleNO3Num

            let total = totalPOSI + totalMR + totalCP + totalCIU + totalNO
            //console.log('total: ', total)

            let median = 33
            let std = 17.67
            let riskFactor = ''
            if(total < (median-std)){
                setRiskFactorText('Low')
                riskFactor = 'Low'
            }
            if(total => (median-std) && total < median){
                setRiskFactorText('Medium')
                riskFactor = 'Medium'
            }
            if(total >= median && total < (median+std)){
                setRiskFactorText('High')
                riskFactor = 'High'
            }
            if(total >= (median+std)){
                setRiskFactorText('Severe')
                riskFactor = 'Severe'
            }


            //reload the screens
            setOnboardingTimeWasted(
            <div className="learningFeedback">
                <div>
                    <p className="questionInfo">  We calculated you will spend <b>{timeSpendYear} days this year</b> on things that leave you drained or unfulfilled. Looking ahead this means that you will spend </p>
                    <h1
                        style={{
                            textAlign: 'center',
                            color: '#FFFFFF',
                            fontFamily: "'Fraunces', serif",
                            fontWeight: 300,
                            fontSize: 'clamp(2.4rem, 8vw, 3.25rem)',
                            lineHeight: 1.1,
                            letterSpacing: '-0.02em',
                            margin: '0 0 0.55rem',
                            textShadow: '0 2px 16px rgba(0, 0, 0, 0.55)',
                            paddingBottom: '1rem'
                        }}
                    >
                        {lifetimeSpend} years
                    </h1>
                    <p className="questionInfo">  of your life lost to patterns that aren’t serving you. What else could you do in <b>{lifetimeSpend} years</b>?</p>

                </div>
                </div> 
            )
            setOnboardingScreenerResults(
                <div className="learningFeedback">
                    <div>
                        <p className="questionInfo"> Conditions like <b>anxiety, depression, and obesity</b> are more common than ever. It's normal to feel overwhelmed but you can change how you respond. Be more present and build</p>
                        <h1
                            style={{
                                textAlign: 'center',
                                color: '#FFFFFF',
                                fontFamily: "'Fraunces', serif",
                                fontWeight: 300,
                                fontSize: 'clamp(2.4rem, 8vw, 3.25rem)',
                                lineHeight: 1.1,
                                letterSpacing: '-0.02em',
                                margin: '0 0 0.55rem',
                                textShadow: '0 2px 16px rgba(0, 0, 0, 0.55)',
                                paddingBottom: '1rem'

                            }}
                        >
                            Resilience
                        </h1>
                        <p className="questionInfo"> at our mental wellness gym. Trampoline Health can help you finally <b>make the change</b>.</p>

                    </div>
                </div>
            )
            setOnboardingCalltoAction(
                <div className="learningFeedback">
                    <div>
                        <p className="questionInfo">  Trampoline can help you recover </p>
                        <h1 style={{ textAlign: 'center'}} >{timeSaved} years +</h1>
                        <p className="questionInfo">  of your life and more importantly help you <b>fill up that time with what matters</b>, like: {personalGoal.toLowerCase()}</p>

                    </div>
                    {/* <div>
                        <p id="relapseImprovementTextBody"> <b>Insight: </b> {relapseImprovementText} </p>
                    </div> */}
                    <div className="formBttnContainer" style={{ bottom: 'calc(1rem + env(safe-area-inset-bottom, 0px))', position: 'fixed' }}>
                        <button className="popupButton"  onClick={handleCloseRelapsePopup} >Start Your First Workout</button>
                        <button style={{ marginTop: '1rem', border: 'none' }} className="popupButton" onClick={() => {window.open("https://whop.com/joined/trampoline-health/wins-goals-and-takeaways-5Hrc6ecDw1APCe/app/", "_blank");}} >Share Progress In Mental Wellness Gym</button>
                    </div>
                </div> 
            )
            //document.getElementsByClassName('popupButtonGroup')[0].style.display = 'none'
            setTimeout(()=>{
                //console.log(document.getElementById('waiting-animation'))
                //console.log(document.getElementById('waiting-text'))
                document.getElementById('waiting-animation').style.display = 'none'
                document.getElementById('waiting-text').style.display = 'block'
                document.getElementsByClassName('popupButtonGroup')[0].style.display = 'flex'
            }, 4000)
        }
        //console.log('status: ', currentQuestion)
    };

    const handlePreviousQuestion = () => {
        setCurrentQuestion(currentQuestion - 1);
    };


    const homeHandler = () => {
        document.getElementById('learningContainer').style.display = 'none'
        document.getElementById('homeContainer').style.display = 'block'
    }


    const handleChatNavigate = () => {
        // Update the input value as the answer for the current question
        //console.log('navigate chat')
        navigate('/chat')
    };

    const handleSubmitLanding= (event) => {
        // //console.log('submitting data to the server')
        // handleNextQuestion()
        alert('submitting data to the server')
        const requestConfig = {
            headers: {
                'x-api-key': 'mCQrNSvy7X5AUdJlF2ybc3LdEFGndN885kzttyvB'
            }
        }
    
        const requestBody = {
            email: email,
            dateofbirth: dateofbirth,
            name: name,
            timeSpent: timeSpent,
            gender: gender,
            triedTreatments: triedTreatments,
            failureReasons: failureReasons,
            currentGoal: currentGoal,
            avoidDifficultThoughtsOrFeelings: caplanScaleMR3,
            missedSocialEngagementsDueToMentalWellness: caplanScaleNO2,
            struggleStayingPresentOrFocused: caplanScaleCIU3,
            mentalWellnessInterferesWithShowingUp: caplanScaleCIU1,
            difficultyRegulatingThoughtsEmotionsWhenOverwhelmed: caplanScaleMR2,
            unhelpfulCopingWhenFeelingDown: caplanScaleNO1,
            username: username,
            token: token,
            date: dateObj.getTime(),
            newPassword: newPassword,
            problematicBehaviors: problematicBehaviors,
            joiningReason: joiningReason,
            aboutYou: aboutYou,
            vizSuccess: vizSuccess,
            friendAdvice: friendAdvice,
            timeCommitment: timeCommitment,
            workoutTime: workoutTime   
        }


        console.log('requestBody: ', requestBody)
        axios.post(onboardingrUrl, requestBody, requestConfig).then(response => {
            // setUserSession(response.data.user, response.data.token);
            // //console.log('blep')
            // setTimeout(()=>{
            //     navigate('/daily-content')
            //     document.querySelector('.header').style.display = 'block'
            // }, 4000)
            //console.log('success')
        }).catch(error => {
            //TODO: fix error of receiving null error
            if(error.response.status === 401 || error.response.status === 403 ){
                setErrorMessage(error.response.data.message);
            }
            else{
                setErrorMessage('Sorry the server is down. Please try again later.');

            }
        })
        handleNextQuestion()
        return

    };

    const handleOpenonboardingPopup = () => {
        setShowPopup(true);
        document.getElementById('onboarding-popup').style.display = "block";
        document.getElementsByClassName("popupContainer")[0].style.visibility =  "visible"
        document.getElementsByClassName("popupButtonGroup")[0].style.visibility =  "visible"
    };

    const handleCloseonboardingPopup = () => {
        setShowPopup(false);
        setCurrentQuestion(0); // Reset the current question when the popup is closed
        setAnswers([]); // Clear the answers when the popup is closed
        document.getElementsByClassName("popupContainer")[0].style.display =  "none"
        document.getElementsByClassName("popupContainer")[0].style.visibility =  "hidden"

    };

    const handleCloseRelapsePopup = () => {
        // navigate('/daily-content')
        navigate('/daily-content', { state: { fromOnboarding: true } });
        document.querySelector('.header').style.display = 'block'
    }


    const renderFormonboarding = () => {
        try{
            const currentQ = questionsonboarding[currentQuestion];
            const { question, options } = currentQ;

            return (
                <div className="formContainer">
                    <div className="landing-onboarding-sheet__header">
                        {(currentQuestion > 0 && currentQuestion < questionsonboarding.length - 1) ? (
                            <button type="button" className="landing-onboarding-top-back" onClick={handlePreviousQuestion} aria-label="Previous step">
                                {backArrowIcon}
                            </button>
                        ) : <span aria-hidden="true" />}
                        <button type="button" className="landing-onboarding-top-close" onClick={handleCloseonboardingPopup} aria-label="Close onboarding">
                            x
                        </button>
                    </div>
                    <div className="landing-onboarding-sheet__body">
                        <div className="landing-onboarding-sheet__body-inner">
                            <h2 className="onboarding-popup-title">{question}</h2>
                            <div className="landing-onboarding-sheet__assets">
                                {currentQ.assets}
                            </div>
                        </div>
                    </div>
                    <div className="popupButtonGroup landing-onboarding-sheet__footer">
                        {currentQuestion === 0 ? (
                            <button type="button" className="homeBttn onboarding-pill-btn onboarding-pill-btn--text" onClick={handleNextQuestion}>
                                Jump in!
                            </button>
                        ) : null}
                        {currentQuestion > 0 && currentQuestion < questionsonboarding.length - 2 ? (
                            <button type="button" className="homeBttn onboarding-pill-btn" onClick={handleNextQuestion} aria-label="Next step">
                                {nextArrowIcon}
                            </button>
                        ) : null}
                        {currentQuestion === questionsonboarding.length - 2 ? (
                            <button type="button" id="relapseSubmit" className="homeBttn onboarding-pill-btn" onClick={handleSubmitLanding} aria-label="Submit onboarding">
                                {nextArrowIcon}
                            </button>
                        ) : null}
                    </div>
                </div>
            );
        }
        catch{
            //console.log('someerro yo onboarding')
        }
    };
    
    // End of Popup
    
    const timeElapsed = Date.now();
    const today = new Date(timeElapsed);
    const todayString = today.toDateString();

    useEffect(() => {
        setOnboardingForm()
        document.querySelector('.header').style.display = 'none'
     }, []);

    useEffect(() => {
        if (!showPopup) {
            return undefined;
        }
        const prevBody = document.body.style.overflow;
        const prevHtml = document.documentElement.style.overflow;
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = prevBody;
            document.documentElement.style.overflow = prevHtml;
        };
    }, [showPopup]);

    return (
        <div className="wrapper" style={{ minHeight: '100dvh', margin: 0, padding: '32px 24px 20px', boxSizing: 'border-box' }}>
            <div className="dailyPopup">
                {/* <button onClick={handleOpenPopup}>hello</button> */}
                {/* #4490C3 */}
                <div className="popupContainer"  id="onboarding-popup"  style={{ display: 'none' }}>{renderFormonboarding()}</div>
            </div>
            <div className="container" id="learningContainer" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', minHeight: 'calc(100dvh - 52px)', width: '100%' }}>
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', minHeight: 0 }}>
                    <div style={{ textAlign: 'center', maxWidth: '640px' }}>
                        <h2 style={{ paddingBottom: '5rem', fontFamily: "'Fraunces', serif", fontWeight: 300, color: '#FFFFFF', lineHeight: 1.2, letterSpacing: '-0.3px', marginBottom: '1.1rem', textShadow: '0 2px 12px rgba(0,0,0,0.4)' }}>
                            Your emotional fitness <br/> journey starts here.
                        </h2>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', maxWidth: '700px', fontSize: '0.95rem', textAlign: 'center', color: 'rgba(255,255,255,0.86)', rowGap: '0.55rem' }}>
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "0.2rem 0.5rem" }}>
                            <svg className="mr-2 h-6 w-6 text-green-500" fill="none" height="24" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><polyline points="20 6 9 17 4 12"></polyline></svg>
                            <span className="text-lg font-medium" style={{ padding: "0.5rem" }}>Create Sustainable Longterm Change</span>
                        </div>
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "0.2rem 0.5rem" }}>
                            <svg className="mr-2 h-6 w-6 text-green-500" fill="none" height="24" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><polyline points="20 6 9 17 4 12"></polyline></svg>
                            <span className="text-lg font-medium" style={{ padding: "0.5rem" }}>Find Community, Accountability, and Support</span>
                        </div>
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "0.2rem 0.5rem" }}>
                            <svg className="mr-2 h-6 w-6 text-green-500" fill="none" height="24" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><polyline points="20 6 9 17 4 12"></polyline></svg>
                            <span className="text-lg font-medium" style={{ padding: "0.5rem" }}>Spend Your Time with More Intention</span>
                        </div>
                    </div>
                </div>
                <div className="homeBttnContainer" style={{ display: 'flex', flexDirection: 'column', position: 'relative', textAlign: 'center', justifyContent: "center", alignItems: 'center', flexShrink: 0, width: '100%', maxWidth: '420px', paddingTop: '1.5rem' }}>
                    <h6 style={{ marginBottom: '0.8rem', color: 'rgba(255,255,255,0.7)', fontWeight: 400 }}>Growing is hard but now you're not alone.</h6>
                    <button className="homeBttn" style={{ marginTop: '0.25rem', background: 'transparent', border: '1px solid rgba(255,255,255,0.45)', borderRadius: '50px', color: '#FFFFFF', maxWidth: '420px', width: '100%', marginBottom: '0.2rem', fontSize: '15px', fontWeight: 500 }} onClick={handleOpenonboardingPopup}>Get Started </button>
                </div>
            </div>
            
        </div>
    )
}


export default LandingForm;
